<template>
  <div class="progress">
    <div class="inner">
      <h2 class="title" v-html="modalTitle"></h2>
      <p class="text" v-html="texts.text"></p>

      <div class="progress-wrapper">
        <div class="progress-bar" :style="`width:${progress}%`"></div>
      </div>
      <div class="steps">
        <div class="steps__inner" :style="`transform:${translateY}`">
          <DeployerDeployProgressStep
            :step-title="texts.steps[0].title"
            :step-description="texts.steps[0].text"
            :step="1"
            :current-step="props.currentStep"
          />
          <DeployerDeployProgressStep
            :step-title="texts.steps[1].title"
            :step-description="texts.steps[1].text"
            :step="2"
            :current-step="props.currentStep"
          />
          <DeployerDeployProgressStep
            :step-title="texts.steps[2].title"
            :step-description="texts.steps[2].text"
            :step="3"
            :current-step="props.currentStep"
          />
          <DeployerDeployProgressStep
            :step-title="texts.steps[3].title"
            :step-description="texts.steps[3].text"
            :step="4"
            :current-step="props.currentStep"
          />
          <DeployerDeployProgressStep
            :step-title="texts.steps[4].title"
            :step-description="texts.steps[4].text"
            :step="props.currentStep"
            :current-step="props.currentStep"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  currentStep: Number,
  deployMaxSteps: Number
})

const progress = computed(() => {
  return props.currentStep * (100 / props.deployMaxSteps)
})

const translateY = computed(() => {
  if (props.currentStep < 5) {
    return `translateY(-${(props.currentStep - 1) * 29}px)`
  } else {
    return `translateY(-116px)`
  }
})

const textsStore = useTextsStore()
const texts = computed(() => {
  return textsStore.deploy.process
})

const modalTitle = computed(() => {
  return `${texts.value.title} <span class="steps">${props.currentStep}/${props.deployMaxSteps}</span>`
})
</script>

<style lang="scss" scoped>
.progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--Page-bg, #0e0e0e);
  z-index: 101;
  text-align: center;

  @media (min-height: 700px) {
    display: flex;
    align-items: center;
  }
  @media (max-height: 699px) {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
}

.inner {
  max-width: 460px;
  width: 100%;
  margin-inline: auto;
}

.title {
  font-size: 3rem;
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 120%;

  :deep(.steps) {
    font-size: 2rem;
    color: var(--Text-50, rgba(0, 0, 0, 0.5));
    background: var(--Banner-5);
    padding: 10px;
    border-radius: 10px;
    position: relative;
    top: -2px;
    letter-spacing: 2px;
  }
}

.text {
  font-size: 1.7rem;
  opacity: 0.8;
}

.steps {
  margin-top: 5px;
  height: 30px;
  padding-top: 5px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      var(--Page-bg, #0e0e0e) 0,
      rgba(255, 255, 255, 0) 20%,
      rgba(255, 255, 255, 0) 70%,
      var(--Page-bg, #0e0e0e) 100%
    );
    z-index: 3;
  }
  &__inner {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;

    transition: transform 0.6s;
    transition-delay: 0.1s;
    // transform: translateY(-50%);
  }
}

.progress-wrapper {
  border-radius: 6px;
  width: calc(100% - 24px);
  max-width: 440px;
  height: 6px;
  margin-top: 30px;
  position: relative;
  margin-inline: auto;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.34;
    border-radius: 6px;

    background: var(--CTA, #3d6ef6);
  }

  @media (min-width: 1024px) {
    margin-top: 60px;
  }
}

.progress-bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 6px;
  background: var(--CTA, #3d6ef6);
  transition: width 0.8s;
}
</style>
